import { Reveal, Chapter } from "./Reveal";

const SPECS = [
  { k: "Face", v: "80 mm wide × 120 mm tall (2:3 portrait)" },
  { k: "Base depth", v: "50 mm" },
  { k: "Material thickness", v: "1.3 mm" },
  { k: "Format", v: "Freestanding L-shaped stand with NFC tap area" },
];

const VIEWS = [
  { src: "/assets/google-nfc-stand-cutout.png", alt: "Angled front view of the white acrylic Google NFC review stand showing its L-shaped base" },
  { src: "/assets/google-nfc-stand-back-cutout.png", alt: "Blank back view of the white acrylic NFC stand" },
];

export const Trust = () => (
  <section className="bg-ink text-white py-28 sm:py-36 relative noise" data-testid="trust-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <Chapter number="07" label="The Hardware" dark />
          <Reveal>
            <h2 className="rvr-title font-display text-4xl md:text-5xl font-bold tracking-tight leading-[1.05]">
              Built like a business tool, <span className="text-white/40">not a gimmick.</span>
            </h2>
          </Reveal>
          <div className="mt-12">
            {SPECS.map((s, i) => (
              <Reveal key={s.k} delay={i * 0.08}>
                <div className="flex justify-between gap-6 py-5 border-t border-white/10 last:border-b" data-testid={`spec-${s.k.toLowerCase().replace(/\s+/g, "-")}`}>
                  <span className="text-white/45 text-sm font-bold tracking-[0.15em] uppercase">{s.k}</span>
                  <span className="text-white text-right font-medium max-w-[60%]">{s.v}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <Reveal delay={0.15}>
          <div className="space-y-4" data-testid="product-views">
            <div className="bg-mist border border-white/10 rounded-sm p-8 flex items-center justify-center">
              <img
                src="/assets/front-google-nfc-angle-cutout.webp"
                alt="White acrylic NFC stand with Google logo, five gold stars, 'Review Us On Google' and a 'Tap your phone' NFC icon"
                loading="lazy"
                className="w-full max-w-[340px] h-auto object-contain [filter:drop-shadow(0_24px_35px_rgba(10,10,10,0.25))]"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              {VIEWS.map((v) => (
                <div key={v.src} className="bg-mist border border-white/10 rounded-sm p-5 flex items-center justify-center">
                  <img src={v.src} alt={v.alt} loading="lazy" className="w-full h-auto max-h-52 object-contain [filter:drop-shadow(0_14px_20px_rgba(10,10,10,0.2))]" />
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
